<template>

  <div>

    <div class="col-lg-12" style="margin-top: 16px;">
      <div class="alert alert-info" role="alert">
        Wybierz ilość minut, godzin lub dni wstecz, aby wyznaczyć moment od którego mają być podsumowywane statystyki przesyłania plików.
        <strong>Ustawienie wszystkich wartości na 0 spowoduje pobranie danych od początku.</strong>
      </div>
    </div>

    <div class="row" style="margin-top: 16px;">
      <div class="col-lg-4">
        <div class="form-group
        ">
          <label for="daysBackwards">Dni wstecz</label>
          <input type="number" class="form-control" id="daysBackwards" v-model="timeBackwardsRequest.daysBackwards">
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group
        ">
          <label for="hoursBackwards">Godziny wstecz</label>
          <input type="number" class="form-control" id="hoursBackwards" v-model="timeBackwardsRequest.hoursBackwards">
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group
        ">
          <label for="minutesBackwards">Minuty wstecz</label>
          <input type="number" class="form-control" id="minutesBackwards" v-model="timeBackwardsRequest.minutesBackwards">
        </div>
      </div>




    </div>

      <div class="row" style="margin-top: 16px;">
        <div>
          <CommonTable2
              :table="tableData"
              rowIdentifier="reportGuid"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :showPaginationTop="false"
              :showPaginationBottom="false"


          />
        </div>


      </div>




  </div>




</template>
<script>


import {log} from "@/state/pinia/log";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import {usePricesManagerModule} from "@/state/pinia/pricesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useReportsManagerModule} from "@/state/pinia";

export default {
  name: "ReportsControlFilesDetailsStage",
  props: {
    drugstoreId:String
  },
  components: {
    CommonTable2

  },
  data() {
    return {
      refreshTable:false,
      tableData: {
        headers: [],
        data: [],
        massActions: [],
      },
      timeBackwardsRequest:{
        minutesBackwards:0,
        hoursBackwards:0,
        daysBackwards:0,
      },
      availableHeaders: [
        {
          text: "Lp.",
          key: "listIndex",
          type: "number",
          sortable: true,
          class:"col-checkbox"
        },
        {
          text: "Guid raportu",
          key: "reportGuid",
          type: "text",
          sortable: true,
          class:"col-mid-text"
        },
        {
          text: "Nazwa raportu",
          key: "reportName",
          type: "text",
          sortable: true,
          class:"col-name"
        },
        {
          text: "Ilość wysłanych plików",
          key: "filesCount",
          type: "number",
          sortable: true,

        },
        {
          text: "Data ostatniej wysyłki",
          key: "lastUploadDate",
          type: "datetime",
          sortable: true,

        },

      ]

    };
  },
  computed: {
    reportsModule(){
      return useReportsManagerModule();
    },

    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    refreshControlFilesDetailsList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych kontrolnych...");

      var payload = {
        daysBackwards: this.timeBackwardsRequest.daysBackwards,
        hoursBackwards: this.timeBackwardsRequest.hoursBackwards,
        minutesBackwards: this.timeBackwardsRequest.minutesBackwards,
        drugstoreId: this.drugstoreId,
      }

      this.refreshTable = false;
      this.reportsModule.httpGetAllReportsFilesCountForDrugstore(payload).then((response) => {
        log.log(response)
        var controlRows = [];
        var fetchedRows = JSON.parse(JSON.stringify(response.data.payload));
        for (var i = 0; i < fetchedRows.length; i++) {
            // add color-scale style to every row depending on lastUploadDate freshness
          fetchedRows[i]['listIndex'] = i + 1;

          const lastUpload = fetchedRows[i]['lastUploadDate'] ? new Date(fetchedRows[i]['lastUploadDate']) : null;
          const now = new Date();
          let rowStyle = '';
          if (lastUpload && !isNaN(lastUpload.getTime())) {
            const diffMs = now - lastUpload;
            const oneDayMs = 24 * 60 * 60 * 1000;
            if (diffMs <= oneDayMs) {
              // success - fresh (<= 1 day)
              rowStyle = 'background-color: #e3f6ed;';
            } else if (diffMs <= 2 * oneDayMs) {
              // warning - between 1 and 2 days
              rowStyle = 'background-color: #fff4cc;';
            } else {
              // danger - older than 2 days
              rowStyle = 'background-color: #fde7e9;';
            }
          } else {
            // unknown date -> treat as danger
            rowStyle = 'background-color: #fde7e9;';
          }
          fetchedRows[i]['row-style'] = rowStyle;

          fetchedRows[i]['lastUploadDate'] = new Date(fetchedRows[i]['lastUploadDate']).toLocaleString();
          controlRows.push(fetchedRows[i]);
        }


        this.tableData['headers'] = this.availableHeaders;

        this.tableData['massActions'] = [];

        this.tableData['data'] = controlRows;
        this.refreshTable = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);

      });
    },
    runAction(event) {
      log.log(event);

    },
    runMassAction(event) {
      log.log(event);
    },
    sort(sort) {
      log.log(sort);
    },
    checkAction(items) {
      log.log(items);
    },


  },
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
    this.refreshControlFilesDetailsList();
  },
  watch: {
    timeBackwardsRequest: {
      handler() {
        this.refreshControlFilesDetailsList();
      },
      deep: true,
    },


  },
};
</script>

<style scoped>


</style>
